import type { FC, HTMLAttributes, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

const DISPLAY_NAME = 'ProductInformation.Footer';

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export const Footer: FC<Props> = ({ className, children, ...props }) => (
  <div className={twMerge('mt-[10px]!', className)} {...props}>
    {children}
  </div>
);

Footer.displayName = DISPLAY_NAME;
